/**申报明细 */
import { $http, buildHeaders } from "./index";

//获取发薪单列表
export const taxdeclareemployee_list = (params) => {
  return $http.get("/admin/TaxDeclareEmployee/index", { params });
};

//导出
export const taxdeclareemployee_export = (params) => {
  return $http.get("/admin/TaxDeclareEmployee/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};
